export default {
  "config": {
    "trial": "driving",
    "id": "sdlp-indiv",
    "type": "dotplot",
    "title": "Individual Driving Performance with Solriamfetol Compared with Placebo<sup>29</sup>",
    "xAxis": {
      "groups": [
        "1",
        "2"
      ],
      "padding": 0.1,
      "label": {
        "text": "Postdose analysis time point",
        "y": 62
      },
      "overrides": {
        "1": "2 hour",
        "2": "6 hour"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": -8,
      "high": 6,
      "inc": 2,
      "label": {
        "text": [
          "SDLP change from <no-break>placebo, cm</no-break>"
        ]
      },
      "arrow": {
        "color": "#000",
        "up": {
          "y1": 0,
          "y2": 5,
          "label": "Impairment"
        },
        "down": {
          "y1": 0,
          "y2": -7.5,
          "label": "Improvement"
        }
      }
    },
    "legend": [],
    "footnotes": [
      "Data for all participants, including those with incomplete driving tests. For participants who did not complete the driving test, data for the part of the drive that was completed were used to calculate SDLP.",
      "A blood alcohol concentration of <no-break>0.5 g/L</no-break> <no-break>(0.05 %)</no-break> is associated with a mean SDLP increase of <no-break>2.5 cm.<sup>13</sup></no-break>"
    ],
    "useFootnoteTooltip": true,
    "trendLines": [
      {
        "y": 0,
        "color": "#000",
        "label": {
          "text": "",
          "textColor": "#000"
        },
        "lineType": "solid"
      }
    ],
    "chartLegend": [],
    "means": []
  },
  "data": [
    {
      "x": 1,
      "dots": [
        {
          "name": "subject",
          "color": "#000",
          "y": -0.33,
          "label": {
            "text": -0.33,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 4.98,
          "label": {
            "text": 4.98,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -4.49,
          "label": {
            "text": -4.49,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.44,
          "label": {
            "text": -0.44,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 2.5,
          "label": {
            "text": 2.5,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.76,
          "label": {
            "text": 0.76,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.07,
          "label": {
            "text": -2.07,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.01,
          "label": {
            "text": -1.01,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.22,
          "label": {
            "text": 0.22,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -3.5,
          "label": {
            "text": -3.5,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 2.7,
          "label": {
            "text": 2.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -3.87,
          "label": {
            "text": -3.87,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -5.52,
          "label": {
            "text": -5.52,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -4.04,
          "label": {
            "text": -4.04,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.83,
          "label": {
            "text": 0.83,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.78,
          "label": {
            "text": -0.78,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.27,
          "label": {
            "text": -0.27,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -3.38,
          "label": {
            "text": -3.38,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -6.96,
          "label": {
            "text": -6.96,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.14,
          "label": {
            "text": -1.14,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -3.1,
          "label": {
            "text": -3.1,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.46,
          "label": {
            "text": -2.46,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.12,
          "label": {
            "text": 0.12,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.62,
          "label": {
            "text": 0.62,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.97,
          "label": {
            "text": -0.97,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 2.7,
          "label": {
            "text": 2.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.67,
          "label": {
            "text": -2.67,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.08,
          "label": {
            "text": -0.08,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.72,
          "label": {
            "text": -0.72,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": null,
          "label": {
            "text": null,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.53,
          "label": {
            "text": 0.53,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.81,
          "label": {
            "text": -1.81,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.34,
          "label": {
            "text": -0.34,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.64,
          "label": {
            "text": -2.64,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 2,
      "dots": [
        {
          "name": "subject",
          "color": "#000",
          "y": -1.79,
          "label": {
            "text": -1.79,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": null,
          "label": {
            "text": null,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": null,
          "label": {
            "text": null,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.65,
          "label": {
            "text": -0.65,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.43,
          "label": {
            "text": 0.43,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.97,
          "label": {
            "text": 0.97,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 1.31,
          "label": {
            "text": 1.31,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.4,
          "label": {
            "text": -1.4,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.25,
          "label": {
            "text": 0.25,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.26,
          "label": {
            "text": -1.26,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 1.79,
          "label": {
            "text": 1.79,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -5.83,
          "label": {
            "text": -5.83,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.7,
          "label": {
            "text": -2.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.69,
          "label": {
            "text": 0.69,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.11,
          "label": {
            "text": 0.11,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.19,
          "label": {
            "text": -2.19,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.79,
          "label": {
            "text": 0.79,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -6.59,
          "label": {
            "text": -6.59,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.85,
          "label": {
            "text": -0.85,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.97,
          "label": {
            "text": -0.97,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.07,
          "label": {
            "text": -2.07,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.47,
          "label": {
            "text": -1.47,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.93,
          "label": {
            "text": 0.93,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -2.27,
          "label": {
            "text": -2.27,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 0.04,
          "label": {
            "text": 0.04,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.2,
          "label": {
            "text": -0.2,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 4.11,
          "label": {
            "text": 4.11,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -1.11,
          "label": {
            "text": -1.11,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.08,
          "label": {
            "text": -0.08,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": null,
          "label": {
            "text": null,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 2.26,
          "label": {
            "text": 2.26,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -3.37,
          "label": {
            "text": -3.37,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": 2.76,
          "label": {
            "text": 2.76,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "subject",
          "color": "#000",
          "y": -0.86,
          "label": {
            "text": -0.86,
            "sup": "",
            "override": ""
          }
        }
      ]
    }
  ]
};